import { getUrlParam } from '@shared/utils/base'
import { ConfigService, product_id_info } from '@/services/config.service';

const isTest = process.env.STAGE === 'test' || process.env.NODE_ENV === 'development'

export class KantuWebService extends ConfigService {
  /** 获取区分场景套餐id */
  get scenePackageId () {
    const sceneName = getUrlParam('scene')
    const scene_info = {
      home: '001',
      wxmc: '010',
      koutu: '101'
    }

    return scene_info[sceneName] ?? '001'
  }

  getTryno= '6200'
  getTitle= '可牛看图'
  wxAppId= 'wx3a78d7213f1f9ee7'
  getPackageId= product_id_info.kantu + this.scenePackageId
  getScenePackageId= this.scenePackageId
  getLogo= require('@/assets/images/kantu/logo.png')
  getOfficialLoginImg= require('@/assets/images/kantu/guide_bg.png')
  getHeaderQrCodeImg= require('@/assets/images/kantu/qrcode_official.png')
  getWebsiteUrl= 'https://pic.keniu.com/'
  getMemberInterestDesc= '提供图片查看、图片编辑、图片美化、图片压缩、修改尺寸、高清放大、添加水印、图片转格式、批量重命名、高级打印、文字识别等权益'
  getMemberProtocolLink= 'https://cdn-official-kantu.knfastpic.com/keniu-kantu/protocol/keniu_kantu_vip.html'
  getUserProtocolLink= 'https://cdn-official-kantu.knfastpic.com/keniu-kantu/protocol/keniu_kantu_license.html'
  getPrivacyPolicyLink= 'https://cdn-official-kantu.knfastpic.com/keniu-kantu/protocol/keniu_privacy.html'
  getMemberInterestImgObj= {
    head: 'https://api-cos.keniu.com/interest/pic/pic_compare_header.png',
    content: 'https://api-cos.keniu.com/interest/pic/pic_compare.png',
  }

  // 产品账号注销须知
  getAccountDeleteProtocolLink= 'https://www.ijinshan.com/privacy/zhuxiaoxuzhi.html'

  getProductInfo= {
    appid: '100',
    secret: '83hk2jah4de4h23fbn283fh23gf28qfh',
    version: 1
  }

  getMemberTypeInfo= {
    normal: 'fastpic_normal',
    diamond: 'fastpic_diamond'
  }

  getOldAccountLoginInfo = {
    img: require('@/assets/images/kantu/old_account_icon.png'),
    text: '极速看图',
    id: '17'
  }

  getLogoffContent= `&nbsp;&nbsp;&nbsp;&nbsp;注销可牛看图账号为不可恢复的操作，建议您在最终确定注销前自行备份本账号相关的所有信息，并请再次确认与账号相关的所有服务均已妥善处理。<br />
  &nbsp;&nbsp;&nbsp;&nbsp;请谨记：注销可牛看图账号，您将无法再使用可牛看图账号或找回您添加的任何内容，包括但不限于：<br />
  1.确认注销后，账号将无法登录，如需使用服务，需注册新账号；<br />
  2.账号信息、身份信息、会员权益等将会被清空且无法找回；<br />
  3.如果您选择注销账号，则视为您自行放弃所购买的可牛看图会员服务，且我们无法协助您恢复。<br />`

  getLogoffSuccessContent= '该账号已注销，相关数据被删除'

  getRequestUrl = isTest ? 'http://baoquvip.testcluster-k8s-01.iweikan.cn/' : 'https://api-keniu-kantu.keniu.com/'
}
